var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScroll(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 59,
    viewBox: "0 0 46 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.53852,
    y: 0.794872,
    width: 42.9231,
    height: 56.6246,
    rx: 20.4017,
    stroke: "white",
    strokeWidth: 1.58974
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2506 39.8077C22.6645 40.2216 23.3355 40.2216 23.7494 39.8077L30.4941 33.063C30.908 32.6491 30.908 31.9781 30.4941 31.5642C30.0802 31.1503 29.4092 31.1503 28.9953 31.5642L23 37.5595L17.0047 31.5642C16.5908 31.1503 15.9198 31.1503 15.5059 31.5642C15.092 31.9781 15.092 32.6491 15.5059 33.063L22.2506 39.8077ZM21.9402 19.4048V39.0583H24.0598V19.4048H21.9402Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll);
export default __webpack_public_path__ + "static/media/scroll.4a6ff90c8d1f484207661017ba012695.svg";
export { ForwardRef as ReactComponent };